import React, { useContext, useEffect, useMemo } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { getValueFromInput } from "util/FormsUtils";
import NumberUtils from "util/NumberUtils";
import Wizard from "components/common/Wizard";
import Routes from "routing/Routes";
import useHistory from "routing/useHistory";
import StepSubscribe from "./StepSubscribe";
import StepReview from "./StepReview";
import StepAuthorize from "./StepAuthorize";
import { StepsContext } from "../common/context/Steps";
import { SidebarContext } from "../common/context/Sidebar";
const Graph = ({ externalInputSubmit = false, onSubmit }) => {
  const { availableSteps, currentStep, isDisabledStep, setAvailableStep, setCurrentStep, setEnabledStep } = useContext(StepsContext);
  const { setFormData } = useContext(FormDataContext);
  const { sidebar, clearSidebar } = useContext(SidebarContext);
  const history = useHistory();
  const wizardSteps = useMemo(() => {
    const handleFieldUpdate = ({ target }, fieldData) => {
      const id = target.name || target.id;
      let value = getValueFromInput(target);
      if (typeof value === "string") {
        value = value.trim();
      }
      if (target.type === "number" && NumberUtils.isNumber(value)) {
        setFormData(id, { ...fieldData, value });
        return;
      }
      setFormData(id, { ...fieldData, value });
    };
    const handleSubmit = (maybeFormData) => {
      clearSidebar();
      const nextStep = availableSteps.indexOf(currentStep) + 1;
      if (availableSteps[nextStep]) {
        const key = availableSteps[nextStep];
        setEnabledStep(key);
        setCurrentStep(key);
      } else if (externalInputSubmit) {
        const formData = maybeFormData || {};
        onSubmit(formData);
      } else {
        history.push(Routes.SYSTEM.INPUTS);
      }
    };
    return [
      {
        key: "authorize",
        title: /* @__PURE__ */ React.createElement(React.Fragment, null, "Graph API Connection Configuration"),
        component: /* @__PURE__ */ React.createElement(StepAuthorize, { onSubmit: handleSubmit, onChange: handleFieldUpdate }),
        disabled: isDisabledStep("authorize")
      },
      {
        key: "subscribe",
        title: /* @__PURE__ */ React.createElement(React.Fragment, null, "Graph API Input Configuration"),
        component: /* @__PURE__ */ React.createElement(StepSubscribe, { onSubmit: handleSubmit, onChange: handleFieldUpdate }),
        disabled: isDisabledStep("subscribe")
      },
      {
        key: "review",
        title: /* @__PURE__ */ React.createElement(React.Fragment, null, "Graph API Final Review"),
        component: /* @__PURE__ */ React.createElement(StepReview, { onSubmit: handleSubmit, externalInputSubmit }),
        disabled: isDisabledStep("review")
      }
    ];
  }, [
    availableSteps,
    clearSidebar,
    currentStep,
    isDisabledStep,
    setCurrentStep,
    setEnabledStep,
    setFormData,
    externalInputSubmit,
    history,
    onSubmit
  ]);
  useEffect(() => {
    if (availableSteps.length === 0) {
      setAvailableStep(wizardSteps.map((step) => step.key));
    }
  }, [availableSteps, setAvailableStep, wizardSteps]);
  return /* @__PURE__ */ React.createElement(
    Wizard,
    {
      steps: wizardSteps,
      activeStep: currentStep,
      onStepChange: setCurrentStep,
      horizontal: true,
      justified: true,
      hidePreviousNextButtons: true
    },
    sidebar
  );
};
export default Graph;
